import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/strategy/$blueprintId")({
  beforeLoad: ({ location, params }) => {
    if (Object.hasOwn(location.search, "portfolioId")) {
      throw redirect({
        to: "/strategy/$blueprintId",
        params,
        search: {},
        replace: true,
      });
    }
  },
  loader: ({ context, params }) => {
    void import("~/features/template/template-route").then(
      ({ preloadTemplateRoute }) => {
        void preloadTemplateRoute(context, params.blueprintId);
      },
    );
  },
});
